module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "scoreDetail",
    attrs: {
      "infinite-scroll-disabled": "loading",
      "infinite-scroll-distance": "10"
    }
  }, [_vm._l((_vm.scoreDetail), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "score-list"
    }, [_c('div', [_c('div', {
      staticClass: "fs-28"
    }, [_vm._v(_vm._s(item.score_event_name_show))]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.created_at))])]), _vm._v(" "), _c('div', {
      staticClass: "score"
    }, [_c('span', [_vm._v(_vm._s(item.symbol == 1 ? '+' : '-'))]), _vm._v(_vm._s(item.score))])])
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading",
    staticStyle: {
      "margin-top": "-.16rem"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/loading.gif"),
      "alt": ""
    }
  })]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-e74c9f96","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/scoreDetail.vue
// module id = 462
// module chunks = 7